import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Select from "react-select";
import swal from "sweetalert2";
import Loader from "../../shared/Loader";
import { reactSelectTheme } from "../../shared/colorScheme";

class GroupSort extends Component {
  constructor(props) {
    super(props);
    this.store = props.store;

    this.state = {
      groupByValue: this.store.groupByValue,
      sort1Value: this.store.sort1Value,
      sort2Value: this.store.sort2Value,
      groupByInverted: this.store.groupByInverted,
      sort1Inverted: this.store.sort1Inverted,
      sort2Inverted: this.store.sort2Inverted,
      modalLoading: false,
    };

    this.cancel = this.cancel.bind(this);
    this.reset = this.reset.bind(this);
    this.save = this.save.bind(this);
    this.isTele = props.isTele;
  }
  render() {
    const darkMode = this.darkMode;
    return (
      <div className="group-sort">
        <div className="fields">
          {this.state.modalLoading && (
            <div className="loader-wrapper">
              <Loader />
            </div>
          )}

          <>
            {!this.isTele && (
              <div className="field">
                <label>Group By</label>
                <Select
                  options={this.store.groupByOptions.slice()}
                  name="group-by"
                  className="Select"
                  classNamePrefix="Select"
                  value={this.state.groupByValue}
                  onChange={(e) => this.setState({ groupByValue: e })}
                  isSearchable={false}
                  theme={reactSelectTheme({ darkMode })}
                />
                <label>
                  <input
                    type="checkbox"
                    onChange={() =>
                      this.setState({
                        groupByInverted: !this.state.groupByInverted,
                      })
                    }
                    defaultChecked={this.store.groupByInverted}
                  />
                  Invert
                </label>
              </div>
            )}
            <div className="field">
              <label>Sort By</label>
              <Select
                options={this.store.sort1Options.slice()}
                name="sort-1"
                className="Select"
                classNamePrefix="Select"
                value={this.state.sort1Value}
                onChange={(e) => this.setState({ sort1Value: e })}
                isSearchable={false}
                theme={reactSelectTheme({ darkMode })}
              />
              <label>
                <input
                  type="checkbox"
                  onChange={() =>
                    this.setState({ sort1Inverted: !this.state.sort1Inverted })
                  }
                  defaultChecked={this.store.sort1Inverted}
                />
                Invert
              </label>
            </div>
            <div className="field">
              <label>Sort By</label>
              <Select
                options={this.store.sort2Options.slice()}
                name="sort-2"
                className="Select"
                classNamePrefix="Select"
                value={this.state.sort2Value}
                onChange={(e) => this.setState({ sort2Value: e })}
                isSearchable={false}
                theme={reactSelectTheme({ darkMode })}
              />
              <label>
                <input
                  type="checkbox"
                  onChange={() =>
                    this.setState({ sort2Inverted: !this.state.sort2Inverted })
                  }
                  defaultChecked={this.store.sort2Inverted}
                />
                Invert
              </label>
            </div>
          </>
        </div>
        <div className="buttons">
          <button onClick={this.cancel}>Cancel</button>
          <button onClick={this.reset}>Reset</button>
          <button onClick={this.save}>Ok</button>
        </div>
      </div>
    );
  }

  get darkMode() {
    return this.props.store.appStore.darkMode;
  }

  reset() {
    this.store.resetGroupSort();
    this.store.saveGroupSort();
    swal.close();
  }
  cancel() {
    this.store.restoreGroupSort();
    swal.close();
  }

  save() {
    this.setState({ modalLoading: true });

    setTimeout(() => {
      // TODO: this should be an action on PatientStore.
      this.store.customSortedPatients = undefined;
      this.store.groupByValue = this.state.groupByValue;
      this.store.sort1Value = this.state.sort1Value;
      this.store.sort2Value = this.state.sort2Value;
      this.store.groupByInverted = this.state.groupByInverted;
      this.store.sort1Inverted = this.state.sort1Inverted;
      this.store.sort2Inverted = this.state.sort2Inverted;
      this.store.saveGroupSort();
      swal.close();
    }, 100);
  }
}

export default inject("store")(observer(GroupSort));
